import React, { ReactNode } from "react";
import styled from "@emotion/styled";
import { Box, Card, CardProps } from "@mui/material";
import { Breadcrumbs } from "../../../Breadcrumbs";

const PageCard = styled(Card)`
  display: flex;
  flex-direction: column;
  margin: ${({ theme }) => theme.spacing(4, 6, 3)};
  padding: ${({ theme }) => theme.spacing(4.5, 4, 4.5)};

  ${({ theme }) => theme.breakpoints.down("sm")} {
    margin: ${({ theme }) => theme.spacing(4, 3, 3)};
    padding: ${({ theme }) => theme.spacing(3, 4, 3)};
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  padding: ${({ theme }) => theme.spacing(4, 6, 5)};

  ${({ theme }) => theme.breakpoints.down("sm")} {
    padding: ${({ theme }) => theme.spacing(4)};
  }
`;
interface Props extends Omit<CardProps, "title"> {
  breadcrumbs?: BreadcrumbItem[];
  cardHeading: ReactNode;
  cardChildren: ReactNode;
  children: ReactNode;
  id?: string;
}

export const CardPageLayout = ({
  breadcrumbs,
  cardHeading,
  cardChildren,
  children,
  id,
  ...rest
}: Props) => {
  return (
    <Box>
      {breadcrumbs && breadcrumbs.length > 0 && (
        <Breadcrumbs items={breadcrumbs} />
      )}
      <PageCard id={id} {...rest}>
        <Box width="100%">
          {cardHeading}
          {cardChildren}
        </Box>
      </PageCard>
      <ContentWrapper>{children}</ContentWrapper>
    </Box>
  );
};
